if (!customElements.get('buy-button')) {
  class BuyButton extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      this.form = document.querySelector(`#${this.getAttribute('js-form-id')}`);

      const variantId = this.form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      const quantity = this.form.querySelector('[name="quantity"]')?.value ?? 1;
      const url = `${this.querySelector('a').getAttribute('href')}/${variantId}:${quantity}`;

      window.location = url;
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('buy-button', BuyButton);
}
